import Marquee from "react-fast-marquee";

export default function MarqueeBanner({
  text = "100 Idee per Verona",
  dark = false,
  speed = 40,
  direction = "left",
}) {
  const items = Array(6).fill(text);
  return (
    <div
      data-testid="marquee-banner"
      className={`py-6 md:py-10 overflow-hidden border-y ${
        dark
          ? "bg-[#0d2c54] border-white/10"
          : "bg-[#f4f4f2] border-[#0a0d14]/10"
      }`}
    >
      <Marquee speed={speed} direction={direction} gradient={false}>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display font-black uppercase tracking-tighter text-[10vw] md:text-[7rem] leading-none mx-6 ${
                dark ? "text-outline-paper" : "text-outline"
              }`}
            >
              {t}
            </span>
            <span
              className={`text-[3vw] md:text-4xl mx-6 ${
                dark ? "text-[#d9381e]" : "text-[#d9381e]"
              }`}
            >
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
